<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconTranscript_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M10.542 1c-1.182 0-2.315.47-3.151 1.305L3.095 6.601a.636.636 0 0 0-.186.45v5.14l-1.723 1.723a.636.636 0 1 0 .9.9l1.718-1.718h5.15c.17 0 .332-.067.451-.187l4.29-4.301A4.457 4.457 0 0 0 10.541 1Zm1.71 2.742a.69.69 0 0 1 0 .975L8.328 8.631h2.219a.636.636 0 1 1 0 1.273H7.05L5.209 11.74c-.059.063-.09.094-.12.094H4.22c-.068 0-.124 0-.124-.062v-.743c0-.062.01-.103.092-.185l7.089-7.103a.69.69 0 0 1 .975 0Z"
        clip-rule="evenodd"
    />
</svg>
